import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { HANDLE_PRESENCE_REPORT } from '../redux/tutorChannelReducer'
import useChannel from '../hooks/useChannel'
import { createConsumer } from '@rails/actioncable'
import { wsUrl } from '../consts/other'
import { useParams } from 'react-router-dom'

interface Props {
  screen: 'lesson' | 'chose-device'
}

const PresenceReporter = ({ screen }: Props) => {
  const { lessonId } = useParams()
  const actionCable = useMemo(() => createConsumer(wsUrl), [])
  const { subscribe, unsubscribe, send, connected } = useChannel(actionCable)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!connected) return
    if (screen === 'lesson') {
      send('tutor_presence_report', {})
    } else {
      send('tutor_leave_lesson_screen', {})
    }
  }, [send, screen, connected])

  useEffect(() => {
    if (connected) {
      setInterval(() => {
        send('ping', {})
      }, 3000)
    }
  }, [send, connected])

  useEffect(() => {
    subscribe(
      { channel: 'PresenceReportChannel', role: 'tutor', lesson_id: lessonId },
      {
        received: (data) => {
          dispatch(HANDLE_PRESENCE_REPORT(data))
        }
      }
    )
    return () => {
      unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <></>
}

export default PresenceReporter
